export default {
  container: {
    padding: '50px',
    textAlign: 'center',
  },
  preloader: {
    fontSize: '100px',
    color: 'rgba(0, 0, 0, 0.125)',
  }
}



// WEBPACK FOOTER //
// ./src/common/Preloader/style.js